module.exports = __webpack_public_path__ + "static/pakmaya-profesyonellere-ozel-b66a052ec04dcaa8cb80ccc7384d65aa.png";